(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4136],{

/***/ 8898:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/step/pricing",
      function () {
        return __webpack_require__(53344);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 53344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61906);






function Index(data) {
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [isOpen2, setIsOpen2] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)("commonAndroid");
    const products = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        var ref;
        const list = Array.isArray(data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.data) ? data.data.data : [];
        return list.filter((row)=>row.id == 1 || row.id == 5 || row.id == 4).sort((a, b)=>parseFloat(a.attributes.renew_price) - parseFloat(b.attributes.renew_price));
    }, [
        data
    ]);
    const [ID, setID] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(()=>products[0] ? parseInt(products[0].id) : null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        var ref;
        if (((ref = products[0]) === null || ref === void 0 ? void 0 : ref.id) != null) {
            localStorage.setItem("ProductID", products[0].id);
            setID(parseInt(products[0].id));
        }
    }, [
        query,
        products
    ]);
    if (products.length < 3) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "bg-[#fff] p-10 text-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-[18px] font-[600]",
                    children: t("Purchase New Package")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mt-2 text-[#666]",
                    children: "Package list unavailable. Please purchase from the website."
                })
            ]
        });
    }
    // 排序后写回，兼容下方原有 data.data.data[n] 用法
    data.data.data = products;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: " bg-[#fff] Sixmd:border-t-[1px] Local-step Blds:shadow-step Blds:rounded-[10px] ".concat(!isOpen && !isOpen2 ? "" : "pb-[50px]"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "pt-[40px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-center mt-2 text-[32px] font-[600] xs:text-[22px]",
                        children: t("Purchase New Package")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "text-center mt-[20px] text-[16px] xs:text-[14px] font-[600] w-[430px] text-[#2F343C] xs:w-[96%] mx-auto",
                        children: [
                            t("Want to connect more devices"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            t("Get another subscription and start monitoring")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                onClick: ()=>{
                    setID(parseInt(data.data.data[0].id)), localStorage.setItem("ProductID", parseInt(data.data.data[0].id));
                },
                className: "w-[460px] h-[84px] mx-auto rounded-[10px] p-[10px] flex items-center justify-between mt-[20px] xs:w-[96%] ".concat(ID === parseInt(data.data.data[0].id) ? "bg-[#B8F3E6] border-[#fff] border-[1px] bg-1m-1 bg-cover" : "border-[#12D8AB] border-[1px] bg-1m bg-cover"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex xs:w-[90%]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                alt: "android",
                                width: 100,
                                height: 100,
                                src: "/images/android/step/1.png",
                                className: "w-[64px] h-[64px]"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "xs:w-[80%] grid items-center ml-[12px] xss:h-0",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-[24px] xs:text-[20px] font-[600] text-[#12D8AB] text-left",
                                        children: t("1 month")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "text-[18px] xs:text-[16px] text-[#222222] text-left font-[600]",
                                        children: [
                                            parseFloat(data.data.data[0].attributes.renew_price),
                                            " USD"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[20px] h-[20px] border-[1px] rounded-full flex items-center mr-4 justify-center ".concat(ID === parseInt(data.data.data[0].id) ? "bg-[#12D8AB] border-[#12D8AB] border-[1px]" : "border-[#12D8AB] border-[1px]"),
                        children: ID === parseInt(data.data.data[0].id) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: "/images/android/step/yes.svg",
                            alt: "yes",
                            width: 10,
                            height: 10,
                            className: "w-[12px] h-[12px]"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                onClick: ()=>{
                    setID(parseInt(data.data.data[1].id)), localStorage.setItem("ProductID", parseInt(data.data.data[1].id));
                },
                className: "w-[460px] h-[84px] mx-auto rounded-[10px] p-[10px] flex items-center justify-between mt-[10px] xs:w-[96%] ".concat(ID === parseInt(data.data.data[1].id) ? "bg-[#B8F3E6] border-[#fff] bg-3m-1 bg-cover border-[1px]" : "border-[#12D8AB] border-[1px] bg-3m bg-cover"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex xs:w-[90%]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                alt: "android",
                                width: 100,
                                height: 100,
                                src: "/images/android/step/2.png",
                                className: "w-[64px] h-[64px]"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "xs:w-[80%] grid items-center ml-[12px] xss:h-0",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-[24px] xs:text-[20px] font-[600] text-[#12D8AB] text-left",
                                        children: t("3 months")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "text-[18px] xs:text-[16px] text-[#222222] text-left font-[600]",
                                        children: [
                                            parseFloat(data.data.data[1].attributes.renew_price),
                                            " USD"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[20px] h-[20px] border-[1px] rounded-full flex items-center mr-4 justify-center ".concat(ID === parseInt(data.data.data[1].id) ? "bg-[#12D8AB] border-[#12D8AB] border-[1px]" : "border-[#12D8AB] border-[1px]"),
                        children: ID === parseInt(data.data.data[1].id) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: "/images/android/step/yes.svg",
                            alt: "yes",
                            width: 10,
                            height: 10,
                            className: "w-[12px] h-[12px]"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                onClick: ()=>{
                    setID(parseInt(data.data.data[2].id)), localStorage.setItem("ProductID", parseInt(data.data.data[2].id));
                },
                className: "w-[460px] h-[84px] mx-auto rounded-[10px] p-[10px] flex items-center justify-between mt-[10px] xs:w-[96%] ".concat(ID === parseInt(data.data.data[2].id) ? "bg-[#B8F3E6] border-[#fff] bg-12m-1 bg-cover border-[1px]" : "border-[#12D8AB] border-[1px] bg-12m bg-cover"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex xs:w-[90%]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                alt: "android",
                                width: 100,
                                height: 100,
                                src: "/images/android/step/3.png",
                                className: "w-[64px] h-[64px]"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "xs:w-[80%] grid items-center ml-[12px] xss:h-0",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-[24px] xs:text-[20px] font-[600] text-[#12D8AB] text-left",
                                        children: t("12 months")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "text-[18px] xs:text-[16px] text-[#222222] text-left font-[600]",
                                        children: [
                                            parseFloat(data.data.data[2].attributes.renew_price),
                                            " USD"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[20px] h-[20px] border-[1px] rounded-full flex items-center mr-4 justify-center ".concat(ID === parseInt(data.data.data[2].id) ? "bg-[#12D8AB] border-[#12D8AB] border-[1px]" : "border-[#12D8AB] border-[1px]"),
                        children: ID === parseInt(data.data.data[2].id) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: "/images/android/step/yes.svg",
                            alt: "yes",
                            width: 10,
                            height: 10,
                            className: "w-[12px] h-[12px]"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/android/step/choose-monitored-device",
                className: "w-[278px] h-[40px] bg-[#12D8AB] rounded-[8px] text-white mx-auto flex items-center justify-center mt-[50px] font-[600]",
                children: t("BUY NOW")
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,1664,9774,2888,179], function() { return __webpack_exec__(8898); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);